import * as Constants from '../constants/';

const initialState = {
  isLoading: false,
  error: null,
  mid: null,
  status: null,
  enabled: false,
  settings: {
    maxTags: 25,
    minConfidence: 0.75,
    prefix: 'MCECT',
    saved: false,
    translationEnabled: 'N',
    translationLanguage: ''
  },
  toast: {
    enabled: false,
    contentKey: null,
    variant: 'success'
  },
  version: 1,
  useNestedTagApi: false,
  locationType: 'all'
};

function reduceError(state, error) {
  console.log(`Receive Activation Error  ${error}`);
  return {
    ...state,
    isLoading: false,
    error: error
  };
}

export default function activation(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_ACTIVATION_STATUS:
      return { ...state, isLoading: true, error: null };
    case Constants.RECEIVE_ACTIVATION_STATUS:
      if (action.error) {
        return reduceError(state, action.error);
      }
      return {
        ...state,
        isLoading: false,
        mid: action.activationStatus.activation
          ? action.activationStatus.activation.mid
          : null,
        status: action.activationStatus.activation
          ? action.activationStatus.activation.status
          : 'inactive',
        enabled:
          !!action.activationStatus.activation &&
          action.activationStatus.activation.status === 'active',
        settings: {
          ...state.settings,
          ...(action.activationStatus.activation
            ? action.activationStatus.activation.config
            : {}),
          saved: action.activationStatus.activation
            ? !!action.activationStatus.activation.mid
            : state.settings.saved
        },
        locationType: action.activationStatus.activation
          ? action.activationStatus.activation.locationType
          : 'all',
        version: action.activationStatus.activation
          ? action.activationStatus.activation.version.toString()
          : null,
        useNestedTagApi: action.activationStatus.activation
          ? action.activationStatus.activation.useNestedTagApi
          : false,
        error: null
      };
    case Constants.REQUEST_LOCATION_AND_LANGUAGE_CHANGE:
    case Constants.REQUEST_ACTIVATION_STATUS_CHANGE:
      return { ...state, isLoading: true, error: null };
    case Constants.RECEIVE_LOCATION_AND_LANGUAGE_CHANGE:
      if (action.error) {
        return reduceError(state, action.error);
      }
      return {
        ...state,
        isLoading: false,
        locationType: action.activationStatus.activation
          ? action.activationStatus.activation.locationType
          : 'all',
        settings: {
          ...state.settings,
          ...(action.activationStatus.activation
            ? action.activationStatus.activation.config
            : {})
        },
        error: null
      };
    case Constants.RECEIVE_ACTIVATION_STATUS_CHANGE:
      if (action.error) {
        return reduceError(state, action.error);
      }
      return {
        ...state,
        isLoading: false,
        status: action.activationStatus.activation
          ? action.activationStatus.activation.status
          : 'inactive',
        enabled:
          !!action.activationStatus.activation &&
          action.activationStatus.activation.status === 'active',
        error: null
      };
    case Constants.REQUEST_ACTIVATION:
      return { ...state, isLoading: true, error: null };
    case Constants.RECEIVE_ACTIVATION:
      if (action.error) {
        return reduceError(state, action.error);
      }
      return {
        ...state,
        isLoading: false,
        mid: action.activationStatus.activation
          ? action.activationStatus.activation.mid
          : null,
        status: action.activationStatus.activation
          ? action.activationStatus.activation.status
          : 'inactive',
        settings: {
          ...state.settings,
          ...(action.activationStatus.activation
            ? action.activationStatus.activation.config
            : {}),
          saved: action.activationStatus.activation
            ? !!action.activationStatus.activation.mid
            : state.settings.saved
        },
        unsavedSettings: null,
        locationType: action.activationStatus.activation
          ? action.activationStatus.activation.locationType
          : 'all',
        enabled:
          !!action.activationStatus.activation &&
          action.activationStatus.activation.status === 'active',
        version: action.activationStatus.activation
          ? action.activationStatus.activation.version.toString()
          : null,
        useNestedTagApi: action.activationStatus.activation
          ? action.activationStatus.activation.useNestedTagApi
          : false,
        error: null
      };
    case Constants.UPDATE_TAG_SETTINGS:
      return {
        ...state,
        settings: {
          maxTags: action.settings.maxTags,
          minConfidence: action.settings.minConfidence,
          prefix: action.settings.prefix,
          saved: true
        },
        unsavedSettings: {
          maxTags: action.settings.maxTags,
          minConfidence: action.settings.minConfidence,
          prefix: action.settings.prefix,
          saved: true
        }
      };
    case Constants.UPDATE_INPUT_ERRORS:
      return {
        ...state,
        inputErrors: {
          ...state.inputErrors,
          [action.inputName]: action.display
        }
      };
    case Constants.SHOW_TOAST:
      return {
        ...state,
        toast: {
          enabled: true,
          contentKey: action.contentKey,
          variant: action.variant
        }
      };
    case Constants.DISMISS_TOAST:
      return {
        ...state,
        toast: {
          enabled: false,
          contentKey: null,
          variant: initialState.toast.variant
        }
      };
    default:
      return state;
  }
}
